
import { defineComponent, reactive } from 'vue'
import { Person } from '../../types'
import { Persons } from '../../utils/persons'

type State = {
  persons: Person[];
  search: string;
  completeIsOpen: boolean;
}

export default defineComponent({
  emits: ['item-click'],
  setup (_, { emit }) {
    const persons: Person[] = Object.values(Persons)
    const state = reactive<State>({
      persons,
      search: '',
      completeIsOpen: false
    })

    function handleInput () {
      if (state.search.length) {
        const key = new RegExp(state.search, 'ig')
        state.persons = persons.filter(p => key.test(p.name))
        state.completeIsOpen = true

        return
      }
      state.completeIsOpen = false
    }

    function handleAutoCompleteClick (item: Person) {
      state.search = item.name
      state.completeIsOpen = false
      emit('item-click', item)
    }

    return {
      state,
      handleInput,
      handleAutoCompleteClick
    }
  }
})
